export enum EligibilitySeverityType {
    Fatal = 1,
    Error = 2,
    Warning = 3,
    Information = 4,
}
